<template>
  <div class="consultation-container">
    <div v-if="examination" id="mole" class="col-lg-12">
      <examinations-header
        product="wound"
        :total-examinations="totalExaminations"
        @mount-image-compare="mountImageCompare"
        @initialize-print="printCase"
      />

      <div class="tab-content">
        <div id="home" class="tab-pane active">
          <div class="row equal-height row-eq-height">
            <div class="col-md-6">
              <div class="col-md-12 px-0">
                <general-info
                  :examination="examination"
                  :user="user"
                  :actions="actions"
                  product="wound"
                  @update:examination="examination = $event"
                  @close-case="closeCase"
                  @print-case="printCase"
                  @update-case-actions="updateCaseActions"
                  @report-issue="showCdrFlagDialog = true"
                />
              </div>
            </div>

            <div class="col-md-6 margin-mobile">
              <div class="col-md-12 px-0">
                <consultation-media
                  :case-id="examination.id"
                  :images="examination.images"
                  product="wound"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <wound-consultation-info :examination="examination" />
          </div>
        </div>

        <div v-if="examination" id="image-compare" class="tab-pane">
          <image-compare
            ref="imageCompare"
            :examination-id="examination.id"
            :type="2"
          />
        </div>
      </div>
    </div>
    <VueJsDialogMixinWrapper
      v-if="!!showPrintDialogWithOptions"
      :data-component="showPrintDialogComponent"
      :data-options="showPrintDialogWithOptions"
      @close="closePrintCase"
    />
    <CdrFlagDialog
      v-if="showCdrFlagDialog"
      :show="showCdrFlagDialog"
      :target-type="cdrScopeType.EXAMINATION"
      :target-id="examination.id"
      :wound-acknowledgement="woundAcknowledgement"
      @close="showCdrFlagDialog = false"
      @created="showCdrFlagDialog = false"
    />
  </div>
</template>

<script>
import ImageCompare from "../AddOns/ImageCompare.vue";
import DiagnoseReply from "../AddOns/DiagnoseReply.vue";
import CustomPrintViewDialog from "../AddOns/PrintCaseView.vue";
import Notifications from "../../Utils/notifications";

import ExaminationsHeader from "../AddOns/ExaminationsHeader.vue";
import GeneralInfo from "../AddOns/GeneralInfo.vue";
import ConsultationMedia from "../AddOns/ConsultationMedia.vue";
import WoundConsultationInfo from "./WoundConsultationInfo.vue";
import VueJsDialogMixinWrapper from "../../../mixins/VueJsDialogMixinWrapper.vue";
import CdrFlagDialog from "../../ClinicalDataRemoval/CdrFlagDialog.vue";
import { CDR_SCOPE_TYPE } from "../../ClinicalDataRemoval/cdr-constants";
import { getWoundAcknowledgement } from "../../ClinicalDataRemoval/wound-acknowledgement";

export default {
  components: {
    VueJsDialogMixinWrapper,
    CdrFlagDialog,
    ImageCompare,
    DiagnoseReply,
    CustomPrintViewDialog,
    ExaminationsHeader,
    GeneralInfo,
    ConsultationMedia,
    WoundConsultationInfo,
  },
  data() {
    return {
      loading: true,
      examination: null,
      comments: {},
      user: {},
      backButtonUri: "/",
      actions: {
        isPrioritized: false,
        isFlagged: false,
        isBookmarked: false,
      },
      images: {},
      totalExaminations: null,
      showPrintDialogComponent: CustomPrintViewDialog,
      showPrintDialogWithOptions: null,
      showCdrFlagDialog: false,
      cdrScopeType: CDR_SCOPE_TYPE,
    };
  },
  computed: {
    woundAcknowledgement() {
      return getWoundAcknowledgement(this.examination);
    },
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      this.loading = true;

      this.user = this.$store.state.user;

      axios
        .get("/api/internal/wounds/" + this.$route.params.id)
        .then((data) => {
          let collection = data.data;
          this.examination = collection.examination;

          this.comments = collection.comments;

          this.actions.isPrioritized = collection.examination.isPrioritized;
          this.actions.isFlagged = collection.examination.isFlagged;
          this.actions.isBookmarked = collection.examination.isBookmarked;

          this.getTotalExaminations();

          this.loading = false;
        })
        .catch((error) => {
          this.userErrorMessage(error);
          this.loading = false;
        });

      localStorage.setItem(
        "last_visited_examination_id",
        this.$route.params.id,
      );
    },
    getTotalExaminations: function () {
      axios
        .get(
          "/api/internal/image-comparer/count-examinations/" +
            this.$route.params.id +
            "?type=2",
        )
        .then((data) => {
          let collection = data.data;
          this.totalExaminations = collection.total_examinations;
        })
        .catch((error) => {
          console.log("Get total examinations error: ", error);
        });
    },
    closeCase: function () {
      axios
        .get("/api/internal/tumour-wound/close/" + this.$route.params.id)
        .then((data) => {
          this.examination.statusName = data.data.examination.statusName;
          this.examination.caseCloseAt = data.data.examination.caseCloseAt;
          Notifications.saveSuccess();
        })
        .catch((error) => {
          this.userErrorMessage(error);
        });
    },
    printCase: function () {
      this.showPrintDialogWithOptions = {
        data: {
          uri: "/api/internal/examinations/" + this.examination.id + "/print",
          caseNo: this.examination.caseNo,
          type: "wound",
        },
      };
    },
    closePrintCase() {
      this.showPrintDialogWithOptions = null;
    },
    updateCaseActions: function (actionName) {
      this.actions[actionName] = this.actions[actionName] ? false : true;

      axios
        .put(
          "/api/internal/tumour-wound/actions/" + this.$route.params.id,
          this.actions,
        )
        .then(() => {
          this.$notify({
            text: this.trans("general.notificationSaved"),
            type: "success",
            duration: 1000,
          });
        })
        .catch((error) => {
          this.userErrorMessage(error);
        });
    },
    mountImageCompare: function () {
      this.$refs.imageCompare.getImages();
    },
  },
};
</script>
